import React from 'react';
import PrivilagePageTable from './privilagePageTable';

const Privilages = (props) => {

  return (
      <PrivilagePageTable></PrivilagePageTable>
  );
}

export default Privilages;
